import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CampaignService } from '../../services/campaign.service';

@Component({
    selector: 'app-new-campaign',
    templateUrl: './new-campaign.component.html',
    styleUrls: ['./new-campaign.component.scss']
})
export class NewCampaignComponent implements OnInit, OnDestroy {
    public title = 'new campaign';
    public showProgressBar = true;
    paymentComponentUrl = '/campaign/complete-payment';

    public constructor(
        public router: Router,
        private campaignService: CampaignService
    ) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this.campaignService.destroyCampaign();
    }

    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload($event: BeforeUnloadEvent): void {
        $event.preventDefault();
        $event.returnValue = '';
    }
}
